const {jQuery: $} = window;
import Cookies from 'js-cookie';
import Utils from "./utils.class";
import Featherlight from "./../lib/featherlight";
import Hubspot from "./Hubspot.class";

export default class Theme {
    #$PB;
    #$main;
    #$html;
    #$body;
    #builder;
    #utils;
    #nav;
    #slider;
    #config;
    #$header;
    #scrollOffset;
    #scrollSpeed;
    #popupCTA;
    #popupExit;
    #popupArrow;
    #popupBlock;
    #popupDefault;
    #hubspot;

    constructor(
        config,
        builder,
        utils,
        nav,
        slider
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#nav = nav;
        this.#slider = slider
        this.#$PB = this.#builder.jQuery;
        this.#$html = $('html');
        this.#$body = $('body');
        this.#$main = $('.site-wrapper');

        this.#$header = $('header.site_header');

        this.#scrollOffset = -50;
        this.#scrollSpeed = 750;

        this.#popupCTA = $('.popup_cta');
        this.#popupExit = $('.popup_cta__exit');
        this.#popupArrow = $('.popup_cta__arrow');
        this.#popupBlock = $('.popup_cta__block');
        this.#popupDefault = $('.popup_cta__default');

        if (window.location.hash == "#dev") {
            Cookies.set("debug", 1);
        }

        this.#hubspot = new Hubspot("8324820");
    }

    __onReady() {
        const me = this;

        this.#utils.log("Theme Ready");
        this.#nav.events();
        this.#slider.setup();

        $(window).on('hashchange', function (e) {
            me.#utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!me.#utils.scrollToHash(location.hash, null, me.#scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').on('click', function (e) {
            let $el = $(this);

            if ($el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                if (!me.#utils.scrollToHash(hash, null, me.#scrollOffset, me.#scrollSpeed)) {
                    e.preventDefault();
                }
            }
        })

        $("#menu-wrapper").mmenu(
            {
                "navbar": {
                    "title": mmtitle,
                },
                "navbars": [
                    {
                        "position": "bottom",
                        "content": [
                            "searchfield"
                        ]
                    }
                ],
                "extensions": [
                    "pagedim-black",
                    "theme-dark",
                    "position-right"
                ],
                "searchfield": {
                    "search": false,
                },
                classNames: {
                    fixedElements: {
                        fixed: "fix",
                        sticky: "stick"
                    }
                }
            }, {
                "searchfield": {
                    "form": {
                        "method": 'GET',
                        "action": homeurl
                    },
                    "input": {
                        "name": 's'
                    }
                }
            }
        );

        me.#popupCTA.on("cycle-post-initialize", function(event, opts) {
            me.utils.log("Popup Slider Init", event, opts);

            me.utils.equalHeight('.popup_cta__default', '.popup_cta');
            me.utils.equalHeight('.popup_cta__block', '.popup_cta');

            if (Cookies.get('popup-cta') != 'closed') {
                $(this).addClass('pc-active');
                $(this).css('height', me.#popupBlock.outerHeight());
            } else {
                $(this).removeClass('pc-active');
                $(this).css('height', me.#popupDefault.outerHeight());
            }

            $(this).css({
                "visibility": "visible",
                "position": "relative"
            });
        }).on("cycle-before", function() {
            me.utils.equalHeight('.popup_cta__default', '.popup_cta');
            me.utils.equalHeight('.popup_cta__block', '.popup_cta');
        }).cycle({
            "fx": "scrollHorz",
            "timeout": 5000,
            "pauseOnHover": true,
            "slides": "> .popup_cta__slide",
            "autoHeight": "container",
            "swipe": true
        });
    }

    __onLoad() {
        const me = this;

        this.#utils.log("Theme Load");
        this.#slider.show();

        this.#utils.equalHeight('.image_callout__text', '.builder-layout');

        this.#$header.addClass('fixed');
        this.#$main.css('padding-top', this.#$header.outerHeight());

        if (location.hash) {
            this.#utils.log("Scroll to Section Load");

            setTimeout(function () {
                me.#utils.scrollToHash(location.hash, null, me.#scrollOffset, me.#scrollSpeed);

            }, 300);
        }

        this.#popupExit.on('click', function () {
            me.#popupCTA.removeClass('pc-active');
            me.#popupCTA.addClass('pc-off');

            // opts.container.on( 'cycle-before', onBefore );
            me.#popupCTA.css('height', me.#popupDefault.outerHeight());
            Cookies.set('popup-cta', 'closed');
        });

        this.#popupArrow.on('click', function () {
            me.#popupCTA.removeClass('pc-off');
            me.#popupCTA.addClass('pc-active');
            me.#popupCTA.css('height', me.#popupBlock.outerHeight());
            Cookies.set('popup-cta', 'open');
        });
    }

    __onResize() {
        this.#$main.css('padding-top', this.#$header.outerHeight());
    }

    get utils() {
        return this.#utils;
    }
}